import React from 'react';
import { profile } from '../mock';
import { ArrowDown, Download, MapPin, Cpu } from 'lucide-react';

export default function Hero() {
  return (
    <section id="scene-01" className="scene">
      <div className="scene-inner">
        <div className="grid md:grid-cols-12 gap-10 items-end">
          <div className="md:col-span-7">
            <div className="flex items-center gap-3 mb-8 reveal">
              <span className="chip"><span className="h-1.5 w-1.5 rounded-full bg-cyan-300 pulse-dot" /> SYSTEM ONLINE</span>
              <span className="chip"><Cpu size={12} /> UNIT: ASTRA LUMEN II</span>
            </div>

            <h1 className="display reveal text-5xl md:text-7xl lg:text-[88px] leading-[0.95] font-semibold tracking-tight">
              <span className="holo-text">PRIBIN K</span>
              <br />
              <span className="holo-text flicker">BENNY.</span>
            </h1>

            <div className="mt-6 flex flex-wrap items-center gap-3 reveal">
              <span className="mono text-xs tracking-[0.3em] text-cyan-300/80">
                ROBOTICS // SOFTWARE // ENGINEER
              </span>
              <span className="inline-flex items-center gap-1 mono text-xs text-cyan-300/60">
                <MapPin size={12} /> London, UK
              </span>
            </div>

            <p className="mt-8 max-w-xl text-cyan-100/75 text-lg md:text-xl leading-relaxed reveal">
              {profile.tagline}
            </p>

            <div className="mt-10 flex flex-wrap items-center gap-3 reveal">
              <a
                href="#scene-02"
                className="btn-primary rounded-md px-5 py-3 mono text-[11px] tracking-[0.3em] uppercase"
              >
                Initiate Tour
              </a>
              <a
                href={profile.resume}
                target="_blank"
                rel="noreferrer"
                className="btn-ghost rounded-md px-5 py-3 mono text-[11px] tracking-[0.3em] uppercase inline-flex items-center gap-2"
              >
                <Download size={14} /> Download Dossier
              </a>
            </div>
          </div>

          <div className="md:col-span-5">
            <div className="relative glass rounded-xl p-5 reveal">
              <span className="corner-bracket tl" />
              <span className="corner-bracket tr" />
              <span className="corner-bracket bl" />
              <span className="corner-bracket br" />
              <div className="flex items-center justify-between mono text-[10px] tracking-[0.3em] text-cyan-300/80">
                <span>UNIT_LOG // 001</span>
                <span className="inline-flex items-center gap-1"><span className="h-1.5 w-1.5 rounded-full bg-emerald-300 pulse-dot" /> LINK STABLE</span>
              </div>
              <div className="divider-line my-4" />
              <ul className="space-y-2 mono text-xs text-cyan-100/80">
                <li className="flex justify-between"><span className="text-cyan-400/70">designation</span><span>Robotics Software Eng.</span></li>
                <li className="flex justify-between"><span className="text-cyan-400/70">operator</span><span>Pribin K Benny</span></li>
                <li className="flex justify-between"><span className="text-cyan-400/70">node</span><span>London / UK</span></li>
                <li className="flex justify-between"><span className="text-cyan-400/70">stack</span><span>ROS2 &middot; Python &middot; CV</span></li>
                <li className="flex justify-between"><span className="text-cyan-400/70">status</span><span className="text-emerald-300">OPEN TO WORK</span></li>
              </ul>
            </div>
          </div>
        </div>

        <div className="absolute left-1/2 -translate-x-1/2 bottom-10 flex flex-col items-center gap-2 mono text-[10px] tracking-[0.4em] text-cyan-200/60">
          <span>SCROLL TO ENGAGE</span>
          <ArrowDown size={14} className="animate-bounce" />
        </div>
      </div>
    </section>
  );
}
